
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResourcesService {

  constructor(
    private readonly  http: HttpClient
  ) { }

  getAllResources() {
    let url = `${environment.baseUrl}/resources/group_by_categories`;
    return this.http.get(url);
  }

/*   getAllServices(appId: string) {
    let url = `${environment.baseUrl}/services?appId=${appId}`;
    return this.http.get(url);
  } */

  getFormByService(resourceId: string) {
    let url = `${environment.baseUrl}/resources/${resourceId}`;
    return this.http.get(url);
  }
}
